module.exports = __webpack_public_path__ + "static/media/cocoPlayground_t.cbf5f39d.svg";